import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const handleHashLink = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const sectionId = href.substring(1);

      // If we're not on the home page, navigate there first
      if (!isHomePage) {
        navigate(`/${href}`);
        // The HomePage component will handle scrolling when it detects the hash
        return;
      }

      // If we're on the home page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const links = [{
    category: 'Company',
    items: [{
      name: 'About',
      href: '#about-section'
    }, {
      name: 'Newsletter',
      href: '#insights'
    }, {
      name: 'Products',
      href: '#products'
    }]
  }, {
    category: 'Solutions',
    items: [{
      name: 'Newsfiliate',
      href: '/products/newsfiliate'
    }, {
      name: 'Growth',
      href: '#growth'
    }, {
      name: 'Consulting',
      href: '#consulting'
    }]
  }];
  return <footer className="bg-white border-t border-gray-100" data-id="element-232">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-233">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12" data-id="element-234">
          <div className="md:col-span-6" data-id="element-235">
            <div className="mb-4" data-id="element-236">
              <Logo data-id="element-237" />
            </div>
            <p className="text-gray-600 mb-6" data-id="element-238">
              AI infrastructure and insight for creators who want sustainable
              growth.
            </p>
          </div>
          <div className="md:col-span-3" data-id="element-239">
            <h4 className="font-medium text-gray-900 mb-4" data-id="element-240">
              {links[0].category}
            </h4>
            <ul className="space-y-3" data-id="element-241">
              {links[0].items.map((link, linkIdx) => <li key={linkIdx} data-id="element-242">
                  {link.href.startsWith('#') ? <a href={link.href} className="text-gray-600 hover:text-blue-600 transition-colors" onClick={e => handleHashLink(e, link.href)} data-id="element-243">
                      {link.name}
                    </a> : <Link to={link.href} className="text-gray-600 hover:text-blue-600 transition-colors" data-id="element-244">
                      {link.name}
                    </Link>}
                </li>)}
            </ul>
          </div>
          <div className="md:col-span-3" data-id="element-245">
            <h4 className="font-medium text-gray-900 mb-4" data-id="element-246">
              {links[1].category}
            </h4>
            <ul className="space-y-3" data-id="element-247">
              {links[1].items.map((link, linkIdx) => <li key={linkIdx} data-id="element-248">
                  {link.href.startsWith('#') ? <a href={link.href} className="text-gray-600 hover:text-blue-600 transition-colors" onClick={e => handleHashLink(e, link.href)} data-id="element-249">
                      {link.name}
                    </a> : <Link to={link.href} className="text-gray-600 hover:text-blue-600 transition-colors" data-id="element-250">
                      {link.name}
                    </Link>}
                </li>)}
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm" data-id="element-251">
          <div data-id="element-252">
            © {new Date().getFullYear()} CreatorBoost.ai. All rights reserved.
          </div>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-253">
            <a href="https://creatorboost.ai/privacy-policy" className="hover:text-blue-600 transition-colors" data-id="element-254">
              Privacy
            </a>
            <a href="https://creatorboost.ai/terms-of-service" className="hover:text-blue-600 transition-colors" data-id="element-255">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
};